// Product Guide JS
document.addEventListener('DOMContentLoaded', () => { 
    const buttons = document.querySelectorAll('.fit-toggle'); 
    const blocks = document.querySelectorAll('.fit-content'); 
    buttons.forEach(button => { button.addEventListener('click', ({ target }) => { 
        const selected = target.dataset.fit; buttons.forEach(btn => btn.classList.toggle('active', btn === target)); blocks.forEach(block => block.classList.toggle('active', block.dataset.fitBlock === selected)); 
    }); 
}); 
});